import { SortDirType } from "../../../common/SortDirType";
import { SortParams } from "../../../common/SortParams";

export const sortByFields = [
  { label: "Created On", value: "CREATED_ON" },
  { label: "Invoice Number", value: "TRANSACTION_NUMBER" },
  { label: "Invoice Type", value: "TYPE" },
  { label: "Amount", value: "SUPPLIER_AMOUNT" },
  { label: "Location", value: "LOCATION_NAME" },
  { label: "Buyer", value: "BUYER_COMPANY_NAME" },
  { label: "Asset Type", value: "ASSET_TYPE" },
  { label: "Booking", value: "BOOKING_NUMBER" },
] as const satisfies Array<{label: string, value: string}>;

export type SupplierInvoiceSortByType = typeof sortByFields[number]['value'];

export interface SupplierInvoiceSortParams extends SortParams {
  sortBy?: SupplierInvoiceSortByType;
  sortDir?: SortDirType
}